import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  let { breadcrumbList } = props
  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">{props.title}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {breadcrumbList ? (
                breadcrumbList.map(item => {
                  return (
                    <BreadcrumbItem key={item.id}>
                      <Link to={item.path}>{item.label}</Link>
                    </BreadcrumbItem>
                  )
                })
              ) : (
                <>
                  <BreadcrumbItem>
                    <Link to="#">{props.title}</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>
                    <Link to="#">{props.breadcrumbItem}</Link>
                  </BreadcrumbItem>
                </>
              )}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  breadcrumbList: PropTypes.array,
  title: PropTypes.string,
}

export default Breadcrumb
